import { useState, type Dispatch, type SetStateAction } from 'react';
import { ChevronDown } from 'lucide-react';
import { options } from '@univdiam/ui/lib/StatusOptions';

import type { SelectedOptionProps, SelectProps } from '@univdiam/ui/type';



// Main dropdown component
function StatusDropDown({
  selectedValue,
  setSelectedValue,
  updateOrderStatus, orderDetail
}: {
  selectedValue: SelectedOptionProps,
  setSelectedValue: Dispatch<SetStateAction<SelectedOptionProps>>,
  updateOrderStatus: (params: { order_id: string; customer_id: string; status: string, orderRef: string }) => void,
  orderDetail: {
    id: string;
    JobTitle: string;
    status: string;
    order_id: string;
    customer_id: string
  },
}) {



  const [toggle, setToggle] = useState(false);

  return (
    <div>
      <DropdownButton
        options={options}
        onChange={(option) => {
          setSelectedValue(option);
          setToggle(false);
          updateOrderStatus({
            order_id: orderDetail.order_id,
            customer_id: orderDetail.customer_id,
            status: option.id,
            orderRef: orderDetail.id.toString()
          })
        }}
        selectedValue={selectedValue}
        toggle={toggle}
        onToggle={() => setToggle((prev) => !prev)}
      />
    </div>
  );
}

// Dropdown button + list
function DropdownButton({ selectedValue, onChange, options, toggle, onToggle }: SelectProps) {
  return (
    <div className="relative inline-block min-w-[180px]">
      {/* Button to open/close dropdown */}
      <button
        className="border rounded-[4px] flex items-center overflow-hidden w-full"
        style={{
          borderColor: selectedValue.borderColor,
          backgroundColor: selectedValue.bgColor
        }}
        onClick={onToggle}
      >
        {selectedValue.icon}
        <span
          className="p-2 border-r text-caption2 h-full w-full text-left"
          style={{ borderColor: selectedValue.borderColor }}
        >
          {selectedValue.label}
        </span>
        <span className="bg-white p-2">
          <ChevronDown size={12} strokeWidth={1} />
        </span>
      </button>

      {/* Dropdown options */}
      <ul
        className={`absolute bg-white border border-gray-300 rounded-md shadow-lg mt-1 w-full max-h-60 overflow-y-auto z-10 text-caption2 ${toggle ? 'block' : 'hidden'
          }`}
      >
        <p className="p-2 border-b border-[#E9EAEB] font-semibold">Change status</p>
        {options.map((option) => (
          <li
            key={option.value}
            className="hover:bg-[#5C6BC010] cursor-pointer p-2 flex items-center justify-between"
            onClick={() => onChange(option)}
          >
            {option.label}
            {option.value === selectedValue.value && (
              <span className="ml-2 text-green-500">✔</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default StatusDropDown;
